module.exports = __webpack_public_path__ + "img/time.45dd8e59.svg";